<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="商品分析"> </pageTitle>
    <basicList ref="table" :config="basicListconfig" @search="searchEvent">
      <template v-slot:additionalFeatures>
        <div class="table">
          <el-table
            :data="basicListconfig.data"
            header-cell-class-name="headerCellStyle"
            cell-class-name="cellStyle"
            style="width: 100%"
            row-key="id"
            resizable
            border
            :show-overflow-tooltip="true"
            :height="basicListconfig.height"
            @sort-change="sortChange"
          >
            <el-table-column
              min-width="320"
              prop="name"
              fixed="left"
              label="品名"
            />
            <el-table-column width="150" prop="class_name" label="分类" />
            <el-table-column width="150" prop="shopname" label="门店" />
            <el-table-column width="100" label="周转天数">
              <template slot-scope="scope">
                <el-input
                  size="small"
                  v-model="scope.row.turnoverdays"
                  placeholder="周转天数"
                  @change="changestock(scope.$index, scope.row.turnoverdays)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="安全库存" align="center">
              <el-table-column width="80" label="当前">
                <template slot-scope="scope">
                  {{
                    scope.row.item_stock_safe ? scope.row.item_stock_safe : 0
                  }}
                </template>
              </el-table-column>
              <el-table-column width="100" label="推荐">
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    v-model="scope.row.item_stock_safe_rem"
                    placeholder="推荐安全库存"
                  ></el-input>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="目标库存" align="center">
              <el-table-column width="80" label="当前">
                <template slot-scope="scope">
                  {{
                    scope.row.item_stock_target
                      ? scope.row.item_stock_target
                      : 0
                  }}
                </template>
              </el-table-column>
              <el-table-column width="100" label="推荐">
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    v-model="scope.row.item_stock_target_rem"
                    placeholder="推荐目标库存"
                  ></el-input>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
              width="150"
              prop="updateday"
              label="提醒日期"
              sortable="custom"
            />
            <el-table-column
              width="100"
              prop="num"
              label="库存"
              sortable="custom"
            />
            <el-table-column
              width="100"
              prop="avg_price"
              label="均价"
              sortable="custom"
            >
              <template slot-scope="scope">
                {{ scope.row.avg_price ? scope.row.avg_price : 0 | money }}
              </template>
            </el-table-column>
            <el-table-column
              min-width="100"
              prop="countsaleorder"
              label="销量"
              sortable="custom"
            >
              <template slot-scope="scope">
                {{ scope.row.salenum ? scope.row.salenum : 0 }}
              </template>
            </el-table-column>
            <el-table-column
              min-width="100"
              prop="salenum"
              label="单数"
              sortable="custom"
            >
              <template slot-scope="scope">
                {{ scope.row.countsaleorder ? scope.row.countsaleorder : 0 }}
              </template>
            </el-table-column>
            <el-table-column
              min-width="100"
              prop="saletotal_money"
              label="销售额"
              sortable="custom"
            >
              <template slot-scope="scope">
                {{
                  scope.row.saletotal_money
                    ? scope.row.saletotal_money
                    : 0 | money
                }}
              </template>
            </el-table-column>
            <el-table-column
              min-width="100"
              prop="saledef_money"
              label="毛利"
              sortable="custom"
            >
              <template slot-scope="scope">
                {{
                  scope.row.saledef_money ? scope.row.saledef_money : 0 | money
                }}
              </template>
            </el-table-column>
            <el-table-column
              min-width="100"
              prop="countbuyorder"
              label="采购量"
              sortable="custom"
            >
              <template slot-scope="scope">
                {{ scope.row.countbuyorder ? scope.row.countbuyorder : 0 }}
              </template>
            </el-table-column>
            <el-table-column
              min-width="100"
              prop="buynum"
              label="采购数"
              sortable="custom"
            >
              <template slot-scope="scope">
                {{ scope.row.buynum ? scope.row.buynum : 0 }}
              </template>
            </el-table-column>
            <el-table-column
              min-width="100"
              prop="avgbuymoney"
              label="采购均价"
              sortable="custom"
            >
              <template slot-scope="scope">
                {{ scope.row.avgbuymoney ? scope.row.avgbuymoney : 0 | money }}
              </template>
            </el-table-column>
            <el-table-column
              min-width="100"
              prop="buymoney"
              label="采购差价"
              sortable="custom"
            >
              <template slot-scope="scope">
                {{ scope.row.buymoney ? scope.row.buymoney : 0 | money }}
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="170"
              align="center"
              fixed="right"
              v-if="showColumn"
            >
              <template slot-scope="scope">
                <div style="display: flex; align-items: center">
                  <template v-if="hasPermission('商品-商品管理-编辑')">
                    <div
                      class="button button_modify"
                      @click="editButton(scope.row, scope.$index)"
                    >
                      <i class="iconfont icon-bianji"></i> 修改
                    </div>
                  </template>
                  <template>
                    <div
                      v-if="hasPermission('商品-商品管理-编辑')"
                      class="button button_modify"
                      @click="jumpButton(scope.$index, scope.row)"
                    >
                      <i class="iconfont el-icon-refresh"></i> 跳过
                    </div>
                  </template>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="table_footer" v-if="basicListconfig.isPage">
            <p class="table_footer_total">
              共{{ basicListconfig.total }}项数据
            </p>
            <el-pagination
              background
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :page-sizes="[10, 50, 100, 500]"
              :current-page.sync="basicListconfig.searchParameters.page"
              :page-size="basicListconfig.searchParameters.limit"
              layout="sizes,prev, pager, next"
              :total="basicListconfig.total"
            >
            </el-pagination>
          </div>
        </div>
      </template>
    </basicList>
  </div>
</template>

<script>
const defaultParameters = {
  page: 1,
  limit: 10,
};
import {
  productList,
  itemClassGetList,
  getshoplist,
} from "@/api/basicConfiguration";
import { updateProductList } from "@/api/product";
import { getRoles } from "@/utils";
import { mapGetters } from "vuex";
export default {
  name: "productAnalysis",
  data() {
    return {
      compId: null,
      userId: null,
      roleId: null,
      shopId: null,
      showColumn: true,
      // 列表组件参数
      basicListconfig: {
        table: true,
        loading: false,
        height: "calc(100vh - 350px)",
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
          {
            label: "商品分类",
            type: "treeselect",
            options: [],
            multiple: true,
            key: "class_id",
          },
          {
            label: "品名/编码",
            type: "input",
            key: "keywords",
          },
          {
            label: "日期",
            type: "quickDate",
            key: "time",
          },
        ],
        data: [],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      storeList: [],
      summarizeData: {},
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    this.obtainDataSource();
    this.searchEvent({
      shop_id: JSON.parse(getRoles()).shop_id,
    });
    this.getlist();
  },
  computed: {
    ...mapGetters(["hasPermission", "getPermissionId"]),
  },
  methods: {
    editButton(data, index) {
      updateProductList({
        comp_id: this.compId,
        shop_id: data.shop_id,
        item_id: data.item_id,
        item_stock_target: data.item_stock_target_rem,
        item_stock_safe: data.item_stock_safe_rem,
        turnoverdays: data.turnoverdays,
      }).then((res) => {
        if (res.code == 1) {
          this.$message.success("操作成功");
          this.$emit("close", 1);
          this.basicListconfig.data[index].updateday = res.updateday;
          this.basicListconfig.data[index].item_stock_target =
            data.item_stock_target_rem;
          this.basicListconfig.data[index].item_stock_safe =
            data.item_stock_safe_rem;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    jumpButton(index, data) {
      updateProductList({
        comp_id: this.compId,
        shop_id: data.shop_id,
        item_id: data.item_id,
        item_stock_target_rem: 0,
        item_stock_safe_rem: 0,
        turnoverdays: 0,
      }).then((res) => {
        if (res.code == 1) {
          this.$message.success("操作成功");
          this.$emit("close", 1);
          this.basicListconfig.data[index].item_stock_target_rem =
            this.basicListconfig.data[index].olditem_stock_target_rem;
          this.basicListconfig.data[index].item_stock_safe_rem =
            this.basicListconfig.data[index].olditem_stock_safe_rem;
          this.basicListconfig.data[index].turnoverdays =
            this.basicListconfig.data[index].oldturnoverdays;
          this.basicListconfig.data[index].updateday = res.updateday;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    changestock(index, turnoverdays) {
      this.basicListconfig.data[index].item_stock_target_rem =
        Math.round(
          this.basicListconfig.data[index].avg_saleday * turnoverdays
        ) == 0
          ? 1
          : Math.round(
              this.basicListconfig.data[index].avg_saleday * turnoverdays
            );
      this.basicListconfig.data[index].item_stock_safe_rem =
        Math.round(
          this.basicListconfig.data[index].avg_saleday * 3 * (turnoverdays / 30)
        ) == 0
          ? 1
          : Math.round(
              this.basicListconfig.data[index].avg_saleday *
                3 *
                (turnoverdays / 30)
            );
    },
    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up = data.order;
      // data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getlist();
    },
    // 搜索方法
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
          if (key == "time") {
            this.basicListconfig.searchParameters["begin_time"] = data[key]
              ? data[key][0]
              : null;
            this.basicListconfig.searchParameters["end_time"] = data[key]
              ? data[key][1]
              : null;
          }
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    handleCurrentChange(val) {
      this.searchEvent(this.searchForm, val, "");
    },
    handleSizeChange(val) {
      this.searchEvent(this.searchForm, "", val);
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.search.map((item) => {
        if (item.key == "shop_id") {
          item.value = this.basicListconfig.searchParameters["shop_id"];
        }
        return item;
      });
      this.basicListconfig.loading = true;
      productList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.total = Number(res.count);
          this.basicListconfig.data = res.list;
          this.showColumn =
            this.basicListconfig.data[0].shop_id == 0 ? false : true;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    // 获取数据源
    obtainDataSource() {
      itemClassGetList().then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "class_id") {
              item.options = this.$findChildren(0, res.data);
            }
            return item;
          });
        } else {
          this.$message.error(res.msg);
        }
      });

      getshoplist({ status: 0, comp_id: JSON.parse(getRoles()).comp_id }).then(
        (res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                });
              }
              return item;
            });
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
  },
};
</script>

<style  scoped>
.search_total {
  display: flex;
  line-height: 32px;
}
.search_total p {
  font-size: 16px;
  padding: 0 10px;
  font-weight: bold;
  color: #ffa100;
}
.search_total p span {
  color: rgba(0, 0, 0, 0.6);
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/views/productAnalysis/index.vue